module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gKM8X"))).then(() => module.bundle.root('jDtFi'));